import React from 'react';
import { COLORS, RADIUS, SIZES, TYPOGRAPHY } from './design-tokens';

const ProductCard = ({ product, index }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `auto ${SIZES.productImageSize} 1fr ${SIZES.productBadgeMinWidth}`,
        gridTemplateRows: SIZES.productMinHeight,
        columnGap: '4mm',
        alignItems: 'center',
        padding: '4mm',
        background: COLORS.card,
        border: `1px solid ${COLORS.line}`,
        borderRadius: RADIUS.card,
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
        flexShrink: 0,
        width: '100%',
        boxSizing: 'border-box',
        wordBreak: 'normal',
        overflowWrap: 'break-word'
      }}
    >
      <div
        style={{
          background: COLORS.primary,
          color: COLORS.card,
          width: '10mm',
          height: '10mm',
          borderRadius: RADIUS.badge,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: '14px',
          flexShrink: 0
        }}
      >
        {String(index + 1).padStart(2, '0')}
      </div>

      <div
        style={{
          width: SIZES.productImageSize,
          height: SIZES.productImageSize,
          background: COLORS.backgroundSecondary,
          borderRadius: RADIUS.image,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: COLORS.placeholder,
          fontSize: '10px',
          flexShrink: 0,
          overflow: 'hidden'
        }}
      >
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        ) : (
          <span>Imagem</span>
        )}
      </div>

      <div
        style={{
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '1mm'
        }}
      >
        <div
          style={{
            fontSize: '10px',
            fontWeight: 600,
            color: COLORS.textSecondary,
            letterSpacing: '1px'
          }}
        >
          {product.category || 'PRODUTO'}
        </div>
        <div style={{ fontSize: '14px', fontWeight: 700, color: COLORS.textPrimary, lineHeight: 1.2 }}>
          {product.name}
        </div>
        <div style={{ fontSize: '11px', color: COLORS.textSecondary, lineHeight: 1.3 }}>
          {product.description}
        </div>
        {product.specifications && product.specifications.length > 0 && (
          <ul style={{ listStyle: 'none', padding: 0, margin: '1mm 0 0 0' }}>
            {product.specifications.slice(0, 4).map((spec, i) => (
              <li
                key={i}
                style={{
                  fontSize: '10px',
                  color: COLORS.textPrimary,
                  lineHeight: 1.4,
                  paddingLeft: '4mm',
                  position: 'relative'
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    left: '1mm',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '1.2mm',
                    height: '1.2mm',
                    borderRadius: '50%',
                    background: COLORS.primary
                  }}
                />
                {spec}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div
        style={{
          background: COLORS.backgroundSecondary,
          color: COLORS.primary,
          padding: '2mm 3mm',
          borderRadius: RADIUS.badge,
          fontSize: '16px',
          fontWeight: 700,
          whiteSpace: 'nowrap',
          textAlign: 'center',
          flexShrink: 0
        }}
      >
        {product.price
          ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0 }).format(product.price)
          : 'R$ --'}
      </div>
    </div>
  );
};

export default ProductCard;
